import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import Styles from './grouppolicyStyle.module.scss';
import ProgressBar from '../../components/ProgressBar/progressbar';
import RebootScheduler from './RebootSheduler';

const MaintananceGroup = () => {
  const navigate = useNavigate();

  const [barCheck, setBarCheck] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (barCheck) {
      setLoading(true); // Start loading when barCheck becomes true

      // Simulate loading time (e.g., 1 second)
      const timer = setTimeout(() => {
        setLoading(false); // Stop loading after delay
      }, 1000);

      // Cleanup timer on unmount or next effect run
      return () => clearTimeout(timer);
    }
  }, [barCheck]);

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Group Policy" dropdown={2} />

        <Card className="flex-1">
          <div className={`${Styles.progressBar} items-center justify-between mb-0`}>
            {/* <ProgressBar stepNum={barCheck ? 3 : 2} identity={'Create Group'} /> */}
            {loading ? (
              <div className="loading-spinner"></div>
            ) : (
              // You can replace with your spinner or skeleton UI
              <ProgressBar stepNum={barCheck ? 3 : 2} identity={'Create Group'} />
            )}
          </div>

          <RebootScheduler setBarCheck={setBarCheck} />
        </Card>
      </div>
    </div>
  );
};

export default MaintananceGroup;
